<div class="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 flex items-center justify-center p-4">
  <div class="w-full max-w-md">
    <div class="bg-white rounded-2xl p-8 relative shadow-xl">
      <!-- Back Button for Non-Initial Modes - Hidden during required password reset -->
  <button
  (click)="close()"
  class="absolute top-3 right-3 flex items-center gap-1.5
         px-3 py-1.5 rounded-full bg-gray-100 text-gray-600
         hover:bg-gray-200 hover:text-gray-800
         active:bg-gray-300 transition-colors duration-200
         focus:outline-none focus:ring-1 focus:ring-gray-300"
>
  <i class="fas fa-times text-base"></i>
  <span class="text-sm font-medium">Close</span>
</button>


      <button *ngIf="currentMode !== 'initial' && !isRequiredPasswordReset" (click)="goBack()"
        class="absolute top-4 left-4 text-gray-500 hover:text-gray-700 transition-colors">
        <i class="fas fa-arrow-left"></i>
      </button>

      <!-- Logo and Title -->
      <div class="text-center mb-8">
        <h1 class="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#F9CC0B] to-[#FFE97F]">
          CleverDeals
        </h1>
        <p class="mt-2 text-xl font-semibold text-gray-800">
          {{
          currentMode === "initial"
          ? "Welcome to CleverDeals"
          : currentMode === "emailSignup"
          ? "Create Your Account"
          : currentMode === "login"
          ? "Log In to CleverDeals"
          : currentMode === "forgotPassword"
          ? "Forgot Password"
          : currentMode === "otpVerification" && isRequiredPasswordReset
          ? "Security Verification Required"
          : currentMode === "otpVerification"
          ? "Verify Your Email"
          : isRequiredPasswordReset
          ? "Reset Your Password"
          : "Reset Your Password"
          }}
        </p>
        <p class="mt-2 text-gray-500">
          {{
          currentMode === "initial"
          ? "Sign up to explore amazing deals"
          : currentMode === "emailSignup"
          ? "Enter your details to get started"
          : currentMode === "login"
          ? ""
          : currentMode === "forgotPassword"
          ? "Enter your email to receive a verification code"
          : currentMode === "otpVerification" && isRequiredPasswordReset
          ? "Enter the 4-digit code sent to your email to secure your account"
          : currentMode === "otpVerification"
          ? "Enter the 4-digit code sent to your email"
          : isRequiredPasswordReset
          ? "Your password must be different from your email address"
          : "Create a new secure password for your account"
          }}
        </p>
      </div>

      <!-- Initial Mode -->
      <ng-container *ngIf="currentMode === 'initial'">
        <div class="space-y-4">
          <!-- CHANGE: Replaced Google icon button with full-width Sign in with Google button -->
          <div id="googleSignInDiv" class="hidden"></div>
          <button (click)="signUpWithGoogle()"
            class="w-full py-3 font-medium text-black rounded-xl bg-gray-100 hover:bg-gray-200 transition-all flex items-center justify-center gap-2">
            <i class="fab fa-google mr-2"></i>
            Sign in with Google
          </button>
           <button (click)="signUpWithFacebook()"
          class="w-full py-3 font-medium text-black rounded-xl bg-gray-100 hover:bg-gray-200 transition-all flex items-center justify-center gap-2 mb-4">
          <i class="fab fa-facebook text-blue-600 mr-2"></i>
          Sign in with Facebook
        </button>

          <!-- Divider -->
          <div class="relative my-6">
            <div class="absolute inset-0 flex items-center">
              <div class="w-full border-t border-gray-200"></div>
            </div>
            <div class="relative flex justify-center text-sm">
              <span class="px-4 bg-white text-gray-500">Or</span>
            </div>
          </div>

          <!-- Email Sign Up Button -->
          <button (click)="showEmailSignUp()"
            class="w-full py-3 font-medium text-black rounded-xl bg-gradient-to-r from-[#F9CC0B] to-[#FFE97F] hover:from-[#E9BC00] hover:to-[#F5DF6F] transition-all flex items-center justify-center gap-2">
            Sign up with Email
            <i class="fas fa-arrow-right ml-2"></i>
          </button>

          <!-- CHANGE: Replaced text link with button for "Already have an account" -->
          <button (click)="showLogin()"
            class="w-full py-3 mt-4 font-medium text-black rounded-xl bg-gradient-to-r from-[#F9CC0B] to-[#FFE97F] hover:from-[#E9BC00] hover:to-[#F5DF6F] transition-all flex items-center justify-center gap-2">
            Already have an account? Log in
          </button>
        </div>
      </ng-container>

      <!-- Email Signup Mode -->
      <ng-container *ngIf="currentMode === 'emailSignup'">
        <form [formGroup]="emailSignupForm" (ngSubmit)="onEmailSignup()" class="space-y-4">
          <!-- First and Last Name -->
          <div class="grid grid-cols-2 gap-4">
            <div>
              <label class="block text-gray-700 mb-2 text-sm">First Name</label>
              <input type="text" formControlName="firstName"
                class="w-full px-4 py-3 bg-gray-50 text-gray-800 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#F9CC0B] focus:border-[#F9CC0B]"
                placeholder="Enter first name" />
              <span *ngIf="
                  emailSignupForm.get('firstName')?.touched &&
                  emailSignupForm.get('firstName')?.invalid
                " class="text-red-500 text-xs mt-1">
                {{
                getErrorMessage(
                emailSignupForm.get("firstName"),
                "First Name"
                )
                }}
              </span>
            </div>
            <div>
              <label class="block text-gray-700 mb-2 text-sm">Last Name</label>
              <input type="text" formControlName="lastName"
                class="w-full px-4 py-3 bg-gray-50 text-gray-800 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#F9CC0B] focus:border-[#F9CC0B]"
                placeholder="Enter last name" />
              <span *ngIf="
                  emailSignupForm.get('lastName')?.touched &&
                  emailSignupForm.get('lastName')?.invalid
                " class="text-red-500 text-xs mt-1">
                {{
                getErrorMessage(emailSignupForm.get("lastName"), "Last Name")
                }}
              </span>
            </div>
          </div>

          <!-- Email Input -->
          <div>
            <label class="block text-gray-700 mb-2 text-sm">Email</label>
            <input type="email" formControlName="email"
              class="w-full px-4 py-3 bg-gray-50 text-gray-800 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#F9CC0B] focus:border-[#F9CC0B]"
              placeholder="Enter your email" />
            <span *ngIf="
                emailSignupForm.get('email')?.touched &&
                emailSignupForm.get('email')?.invalid
              " class="text-red-500 text-xs mt-1">
              {{ getErrorMessage(emailSignupForm.get("email"), "Email") }}
            </span>
          </div>

          <!-- Password Input -->
          <div>
            <label class="block text-gray-700 mb-2 text-sm">Password</label>
            <div class="relative">
              <input [type]="showPassword ? 'text' : 'password'" formControlName="password"
                class="w-full px-4 py-3 bg-gray-50 text-gray-800 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#F9CC0B] focus:border-[#F9CC0B]"
                placeholder="Create a password" />
              <button type="button" (click)="togglePasswordVisibility('password')"
                class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700">
                <i class="fas" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
              </button>
            </div>
            <span *ngIf="
                emailSignupForm.get('password')?.touched &&
                emailSignupForm.get('password')?.invalid
              " class="text-red-500 text-xs mt-1">
              {{ getErrorMessage(emailSignupForm.get("password"), "Password") }}
            </span>
          </div>

          <!-- Confirm Password Input -->
          <div>
            <label class="block text-gray-700 mb-2 text-sm">Confirm Password</label>
            <div class="relative">
              <input [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword"
                class="w-full px-4 py-3 bg-gray-50 text-gray-800 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#F9CC0B] focus:border-[#F9CC0B]"
                placeholder="Confirm your password" />
              <button type="button" (click)="togglePasswordVisibility('confirmPassword')"
                class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700">
                <i class="fas" [ngClass]="showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
              </button>
            </div>
            <span *ngIf="
                emailSignupForm.get('confirmPassword')?.touched &&
                (emailSignupForm.get('confirmPassword')?.invalid ||
                  emailSignupForm.hasError('passwordMismatch'))
              " class="text-red-500 text-xs mt-1">
              {{
              emailSignupForm.hasError("passwordMismatch")
              ? "Passwords do not match"
              : getErrorMessage(
              emailSignupForm.get("confirmPassword"),
              "Confirm Password"
              )
              }}
            </span>
          </div>

          <!-- Create Account Button -->
          <button type="submit" [disabled]="emailSignupForm.invalid || signupLoading"
            class="w-full py-3 font-medium text-black rounded-xl bg-gradient-to-r from-[#F9CC0B] to-[#FFE97F] hover:from-[#E9BC00] hover:to-[#F5DF6F] transition-all flex items-center justify-center gap-2 disabled:opacity-50 mt-2">
            Create Account
            <i *ngIf="signupLoading" class="fas fa-spinner fa-spin ml-2"></i>
          </button>
        </form>

        <!-- Divider -->
        <div class="relative my-6">
          <div class="absolute inset-0 flex items-center">
            <div class="w-full border-t border-gray-200"></div>
          </div>
          <div class="relative flex justify-center text-sm">
            <span class="px-4 bg-white text-gray-500">Or</span>
          </div>
        </div>

        <!-- CHANGE: Replaced Google icon button with full-width Sign in with Google button -->
        <div id="googleLoginDiv" class="hidden"></div>
        <button type="button" (click)="signUpWithGoogle()"
          class="w-full py-3 font-medium text-black rounded-xl bg-gray-100 hover:bg-gray-200 transition-all flex items-center justify-center gap-2 mb-4">
          <i class="fab fa-google mr-2"></i>
          Sign in with Google
        </button>
         <button (click)="signUpWithFacebook()"
          class="w-full py-3 font-medium text-black rounded-xl bg-gray-100 hover:bg-gray-200 transition-all flex items-center justify-center gap-2 mb-4">
          <i class="fab fa-facebook text-blue-600 mr-2"></i>
          Sign in with Facebook
        </button>
      </ng-container>

      <!-- Login Mode -->
      <ng-container *ngIf="currentMode === 'login'">
        <form [formGroup]="loginForm" (ngSubmit)="onLogin()" class="space-y-4">
          <!-- Email Input -->
          <div>
            <label class="block text-gray-700 mb-2 text-sm">Email</label>
            <input type="email" formControlName="email"
              class="w-full px-4 py-3 bg-gray-50 text-gray-800 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#F9CC0B] focus:border-[#F9CC0B]"
              placeholder="Enter your email" />
            <span *ngIf="
                loginForm.get('email')?.touched &&
                loginForm.get('email')?.invalid
              " class="text-red-500 text-xs mt-1">
              {{ getErrorMessage(loginForm.get("email"), "Email") }}
            </span>
          </div>

          <!-- Password Input -->
          <div>
            <label class="block text-gray-700 mb-2 text-sm">Password</label>
            <div class="relative">
              <input [type]="showPassword ? 'text' : 'password'" formControlName="password"
                class="w-full px-4 py-3 bg-gray-50 text-gray-800 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#F9CC0B] focus:border-[#F9CC0B]"
                placeholder="Enter your password" />
              <button type="button" (click)="togglePasswordVisibility('password')"
                class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700">
                <i class="fas" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
              </button>
            </div>
            <p class="text-sm text-gray-600 mt-1">
              If you pre-registered, your password is the same as your email
              address
            </p>
            <span *ngIf="
                loginForm.get('password')?.touched &&
                loginForm.get('password')?.invalid
              " class="text-red-500 text-xs mt-1">
              {{ getErrorMessage(loginForm.get("password"), "Password") }}
            </span>
          </div>

          <!-- Forgot Password Link -->
          <div class="text-right">
            <a (click)="forgotPassword()"
              class="text-[#F9CC0B] hover:text-[#E9BC00] text-sm transition-colors cursor-pointer">
              Forgot Password?
            </a>
          </div>

          <!-- Login Button -->
          <button type="submit" [disabled]="loginForm.invalid || loginLoading"
            class="w-full py-3 font-medium text-black rounded-xl bg-gradient-to-r from-[#F9CC0B] to-[#FFE97F] hover:from-[#E9BC00] hover:to-[#F5DF6F] transition-all flex items-center justify-center gap-2 disabled:opacity-50">
            Log In
            <i *ngIf="loginLoading" class="fas fa-spinner fa-spin ml-2"></i>
          </button>
        </form>

        <!-- Divider -->
        <div class="relative my-6">
          <div class="absolute inset-0 flex items-center">
            <div class="w-full border-t border-gray-200"></div>
          </div>
          <div class="relative flex justify-center text-sm">
            <span class="px-4 bg-white text-gray-500">Or</span>
          </div>
        </div>

        <!-- CHANGE: Replaced Google icon button with full-width Sign in with Google button -->
        <div id="googleLoginDiv" class="hidden"></div>
        <button type="button" (click)="signUpWithGoogle()"
          class="w-full py-3 font-medium text-black rounded-xl bg-gray-100 hover:bg-gray-200 transition-all flex items-center justify-center gap-2 mb-4">
          <i class="fab fa-google mr-2"></i>
          Sign in with Google
        </button>
        <button (click)="signUpWithFacebook()"
          class="w-full py-3 font-medium text-black rounded-xl bg-gray-100 hover:bg-gray-200 transition-all flex items-center justify-center gap-2 mb-4">
          <i class="fab fa-facebook text-blue-600 mr-2"></i>
          Sign in with Facebook
        </button>


        <!-- Sign Up Link -->
        <p class="text-center mt-4 text-gray-500">
          Don't have an account?
          <a (click)="goBack()"
            class="text-[#F9CC0B] hover:text-[#E9BC00] transition-colors cursor-pointer font-medium">
            Sign up
          </a>
        </p>
      </ng-container>

      <!-- Forgot Password Mode -->
      <ng-container *ngIf="currentMode === 'forgotPassword'">
        <form [formGroup]="forgotPasswordForm" (ngSubmit)="requestOTP()" class="space-y-4">
          <!-- Email Input -->
          <div>
            <label class="block text-gray-700 mb-2 text-sm">Email Address</label>
            <input type="email" formControlName="email"
              class="w-full px-4 py-3 bg-gray-50 text-gray-800 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#F9CC0B] focus:border-[#F9CC0B]"
              placeholder="Enter your email" />
            <span *ngIf="
                forgotPasswordForm.get('email')?.touched &&
                forgotPasswordForm.get('email')?.invalid
              " class="text-red-500 text-xs mt-1">
              {{ getErrorMessage(forgotPasswordForm.get("email"), "Email") }}
            </span>
          </div>

          <!-- Submit Button -->
          <button type="submit" [disabled]="forgotPasswordForm.invalid || forgotPasswordLoading"
            class="w-full py-3 font-medium text-black rounded-xl bg-gradient-to-r from-[#F9CC0B] to-[#FFE97F] hover:from-[#E9BC00] hover:to-[#F5DF6F] transition-all flex items-center justify-center gap-2 disabled:opacity-50 mt-2">
            Send Verification Code
            <i *ngIf="forgotPasswordLoading" class="fas fa-spinner fa-spin ml-2"></i>
          </button>

          <!-- Back to Login - Only shown if not in required password reset flow -->
          <p *ngIf="!isRequiredPasswordReset" class="text-center mt-4 text-gray-500">
            Remember your password?
            <a (click)="showLogin()"
              class="text-[#F9CC0B] hover:text-[#E9BC00] transition-colors cursor-pointer font-medium">
              Log in
            </a>
          </p>
        </form>
      </ng-container>

      <!-- OTP Verification Mode -->
      <ng-container *ngIf="currentMode === 'otpVerification'">
        <form [formGroup]="otpVerificationForm" (ngSubmit)="verifyOTP()" class="space-y-4">
          <!-- OTP Input -->
          <div>
            <label class="block text-gray-700 mb-2 text-sm">Verification Code</label>
            <input type="text" formControlName="otp"
              class="w-full px-4 py-3 bg-gray-50 text-gray-800 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#F9CC0B] focus:border-[#F9CC0B] text-center tracking-widest text-xl"
              placeholder="Enter 4-digit code" maxlength="4" autocomplete="one-time-code" />
            <span *ngIf="
                otpVerificationForm.get('otp')?.touched &&
                otpVerificationForm.get('otp')?.invalid
              " class="text-red-500 text-xs mt-1 block text-center">
              {{ otpVerificationForm.get('otp')?.errors?.['required'] ? 'Verification code is required' : 'Enter a valid
              4-digit code' }}
            </span>
          </div>

          <!-- Email Sent To -->
          <p class="text-center text-sm text-gray-500">
            We've sent a verification code to
            <strong>{{ forgotPasswordEmail }}</strong>
          </p>
          <!-- Verify Button -->
          <button type="submit" [disabled]="otpVerificationForm.invalid || otpVerificationLoading"
            class="w-full py-3 font-medium text-black rounded-xl bg-gradient-to-r from-[#F9CC0B] to-[#FFE97F] hover:from-[#E9BC00] hover:to-[#F5DF6F] transition-all flex items-center justify-center gap-2 disabled:opacity-50 mt-2">
            Verify Code
            <i *ngIf="otpVerificationLoading" class="fas fa-spinner fa-spin ml-2"></i>
          </button>

          <!-- Resend Code -->
          <div class="text-center mt-4">
            <button type="button" (click)="resendOTP()" [disabled]="resendDisabled || forgotPasswordLoading"
              class="text-[#F9CC0B] hover:text-[#E9BC00] transition-colors cursor-pointer font-medium disabled:text-gray-400 disabled:cursor-not-allowed">
              {{
              resendDisabled
              ? "Resend code in " + resendCountdown + "s"
              : "Resend code"
              }}
              <i *ngIf="forgotPasswordLoading" class="fas fa-spinner fa-spin ml-2"></i>
            </button>
          </div>
        </form>
      </ng-container>

      <!-- Reset Password Mode -->
      <ng-container *ngIf="currentMode === 'resetPassword'">
        <form [formGroup]="resetPasswordForm" (ngSubmit)="resetPassword()" class="space-y-4">
          <!-- New Password Input -->
          <div>
            <label class="block text-gray-700 mb-2 text-sm">New Password</label>
            <div class="relative">
              <input [type]="showNewPassword ? 'text' : 'password'" formControlName="newPassword"
                class="w-full px-4 py-3 bg-gray-50 text-gray-800 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#F9CC0B] focus:border-[#F9CC0B]"
                placeholder="Create new password" />
              <button type="button" (click)="togglePasswordVisibility('newPassword')"
                class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700">
                <i class="fas" [ngClass]="showNewPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
              </button>
            </div>
            <span *ngIf="
                resetPasswordForm.get('newPassword')?.touched &&
                resetPasswordForm.get('newPassword')?.invalid &&
                !resetPasswordForm.get('newPassword')?.errors?.['sameAsEmail']
              " class="text-red-500 text-xs mt-1">
              {{
              getErrorMessage(
              resetPasswordForm.get("newPassword"),
              "New Password"
              )
              }}
            </span>
            <!-- Add special error message for when password matches email -->
            <span *ngIf="
                resetPasswordForm.get('newPassword')?.errors?.['sameAsEmail']
              " class="text-red-500 text-xs mt-1">
              Password cannot be the same as your email address
            </span>
          </div>

          <!-- Confirm New Password Input -->
          <div>
            <label class="block text-gray-700 mb-2 text-sm">Confirm New Password</label>
            <div class="relative">
              <input [type]="showConfirmNewPassword ? 'text' : 'password'" formControlName="confirmNewPassword"
                class="w-full px-4 py-3 bg-gray-50 text-gray-800 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#F9CC0B] focus:border-[#F9CC0B]"
                placeholder="Confirm new password" />
              <button type="button" (click)="togglePasswordVisibility('confirmNewPassword')"
                class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700">
                <i class="fas" [ngClass]="showConfirmNewPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
              </button>
            </div>
            <span *ngIf="
                resetPasswordForm.get('confirmNewPassword')?.touched &&
                (resetPasswordForm.get('confirmNewPassword')?.invalid ||
                  resetPasswordForm.hasError('passwordMismatch'))
              " class="text-red-500 text-xs mt-1">
              {{
              resetPasswordForm.hasError("passwordMismatch")
              ? "Passwords do not match"
              : getErrorMessage(
              resetPasswordForm.get("confirmNewPassword"),
              "Confirm Password"
              )
              }}
            </span>
          </div>

          <!-- Password Requirements -->
          <div class="text-xs text-gray-500 space-y-1">
            <p class="text-sm font-medium text-gray-700">
              Your password should:
            </p>
            <p>• Be at least 6 characters long</p>
            <p>• Include at least one uppercase letter</p>
            <p>• Include at least one special character</p>
            <!-- Add this requirement specifically for required password reset -->
            <p *ngIf="isRequiredPasswordReset">
              • Be different from your email address
            </p>
          </div>

          <!-- Reset Button -->
          <button type="submit" [disabled]="resetPasswordForm.invalid || resetPasswordLoading"
            class="w-full py-3 font-medium text-black rounded-xl bg-gradient-to-r from-[#F9CC0B] to-[#FFE97F] hover:from-[#E9BC00] hover:to-[#F5DF6F] transition-all flex items-center justify-center gap-2 disabled:opacity-50 mt-2">
            {{ isRequiredPasswordReset ? "Update Password" : "Reset Password" }}
            <i *ngIf="resetPasswordLoading" class="fas fa-spinner fa-spin ml-2"></i>
          </button>

          <!-- Back to Login - Only shown if not in required password reset flow -->
          <p *ngIf="!isRequiredPasswordReset" class="text-center mt-4 text-gray-500">
            Remember your password?
            <a (click)="showLogin()"
              class="text-[#F9CC0B] hover:text-[#E9BC00] transition-colors cursor-pointer font-medium">
              Back to Login
            </a>
          </p>
        </form>
      </ng-container>
    </div>
  </div>
</div>